<script setup>
import {ref, computed, defineProps} from 'vue';
import {APIService} from '@/core/util/services/api.service';
import usePaginate from '@/core/util/composable/usePaginate';
import States from '../../../orangehrmTrainigPlugin/constants/States';
import TrainigTypes from '../../../orangehrmTrainigPlugin/constants/TrainingTypes';
import UserRoles from '../../../orangehrmTrainigPlugin/constants/UserRoles';
import {navigate} from '@/core/util/helper/navigation';

const http = new APIService(window.appGlobal.baseUrl, `api/training`);

const informationNormalizer = data => {
  return data.map(item => {
    return {
      id: item.id,
      encryptedTrainingId: item.encrypted_training_id,
      internalId: `TRN-${item.id < 10 ? '0' : ''}${item.id}`,
      training: item.title,
      owner: item.owner,
      trainer: item.trainer.map(val => val.name).join(' / '),
      department: item.department.map(val => val.name).join(' / '),
      subUnit: item.subunit.map(val => val.name).join(' / '),
      startDate: item.start_date,
      dueDate: item.due_date,
      type: TrainigTypes.find(val => val.id == item.training_type).label,
      typeId: item.training_type,
      status: States.find(val => val.id == item.status).label,
      certifications: item.certifications,
      encryptedEmployeeId: item.encrypted_employee_id,
      relevantJob: item.relevant_job,
      _loading: item._loading,
    };
  });
};

const props = defineProps({
  employeeId: {type: Number},
});

const serializedFilters = computed(() => {
  return {
    relevantJob: true,
    employeeId: props.employeeId,
  };
});

const {
  showPaginator,
  currentPage,
  total,
  pages,
  pageSize,
  response,
  isLoading,
  execQuery,
} = usePaginate(http, {
  normalizer: informationNormalizer,
  query: serializedFilters,
  pageSize: 5,
  toastNoRecords: false,
});

const onClickView = item => {
  navigate('/training/viewTrainingPlan/{id}', {id: item.id});
};

const headers = ref([
  {name: 'training', title: 'Training', style: {flex: 1}},
  {name: 'trainer', title: 'Trainer', style: {flex: 1}},
  {name: 'department', title: 'Department', style: {flex: 1}},
  {name: 'subUnit', title: 'Sub Unit', style: {flex: 1}},
  {name: 'startDate', title: 'Start Date', style: {flex: 1}},
  {name: 'type', title: 'Type', style: {flex: 1}},
  {name: 'status', title: 'Status', style: {flex: 1}},
  {
    name: 'actions',
    title: 'Actions',
    style: {flex: 1},
    cellType: 'oxd-table-cell-actions',
    cellConfig: {
      view: {
        onClick: onClickView,
        props: {
          name: 'eye',
        },
      },
    },
  },
]);
</script>
<template>
  <div class="orangehrm-horizontal-padding orangehrm-vertical-padding">
    <oxd-text tag="h6" class="orangehrm-main-title">
      Training
    </oxd-text>
  </div>
  <div class="orangehrm-paper-container">
    <div class="orangehrm-container">
      <oxd-card-table
        :headers="headers"
        :items="response?.data"
        :selectable="false"
        :clickable="false"
        :loading="isLoading"
        row-decorator="oxd-table-decorator-card"
      />
    </div>
    <div class="orangehrm-bottom-container">
      <oxd-pagination
        v-if="showPaginator"
        v-model:current="currentPage"
        :length="pages"
      />
    </div>
  </div>
</template>
